const routes = [
    {
        path: '/analise-desmatamento',
        name: 'analise-desmatamento',
        component: () =>
            import('@/modules/analise-desmatamento/views/list/index.vue'),
        props: true,
        meta: {
            roles: ['ROLE_REGENAG_FEATURE_ANALISE_DESMATAMENTO']
        }
    }
];

export default routes;
